/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class RenderContextAPI
 * @hideconstructor
 * @classdesc defines the render context API available in task callbacks
 */
define([], () => {
	class RenderContextAPI {

		/**
		 * @public
		 * @function RenderContextAPI#getSequenceId
		 * @description gets the sequence id
		 * @return {Integer} sequence id
		 */
		getSequenceId() {}

		/**
		 * @public
		 * @function RenderContextAPI#getData
		 * @description retrieves a property 
		 * @param {string} name - name of the property
		 * @return {Object} the property data; undefined when name is undefined or no data exists for the given name
		 */
		getData() {}

	}

	return RenderContextAPI;
});